module.exports = __webpack_public_path__ + "img/nodata02 .ca609385.png";